// extracted by mini-css-extract-plugin
export default {"component":"accordion_component__COfuw","header":"accordion_header__f2OXb","question":"accordion_question__B3wH2","icon":"accordion_icon__qLPJl","answer":"accordion_answer__ljfvK"};